import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import TextInput from "src/Components/Authentication/TextInput";
import PhoneNumberInput from "src/Components/Authentication/PhoneNumberInput";
import PasswordInput from "src/Components/Authentication/PasswordInput";
import ConfirmPasswordInput from "src/Components/Authentication/ConfirmPasswordInput";
import BlueButton from "src/Components/Authentication/BlueButton";
import { validatePassword, API_URL } from "src/Common/function";
import InviteService from "src/Services/API/invite.service";

function SetPassword() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  let token = searchParams.get("token");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({ name: false, phone: false, password: false, confirmPassword: false });

  const blueButtonClicked = () => {
    setSubmitted(true);
    const passwordResult = validatePassword(password);
    const nextErrors = {
      name: !name.trim(),
      phone: !phone,
      password: !passwordResult.success,
      confirmPassword: !confirmPassword || password !== confirmPassword,
    };
    setErrors(nextErrors);

    if (nextErrors.name) {
      toast("Please enter your name");
      return;
    }
    if (nextErrors.phone) {
      toast("Please enter a valid phone number");
      return;
    }
    if (nextErrors.password) {
      toast(passwordResult.message || "Please enter strong password");
      return;
    }
    if (nextErrors.confirmPassword) {
      toast("Passwords doesn't match");
      return;
    }

    setIsLoading(true);
    InviteService.accept({ token, password, name, phone })
      .then(function (response) {
        console.log("response: ", response);
        toast("Password has been set");
        navigate("/");
        setIsLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        // Surface the server's message (e.g. an already-accepted invite)
        // instead of a generic error.
        if (error.response?.data?.message) {
          toast(error.response.data.message);
        } else {
          toast("An error occurred");
        }
        setIsLoading(false);
      });
  };

  return (
    <div className="w-screen h-screen flex items-center justify-center">
      <div className="w-[332px] h-[411px] flex items-center justify-center">
        <div className="w-[296px] h-[400px]">
          <p className="font-OpenSansRegular text-[16px] text-titleColor text-center font-[700]">Set Password</p>
          <p className="font-OpenSansRegular text-[12px] text-subTitleColor text-center font-[600] mt-[5px]">
            Fill in your name and password.
          </p>
          <div className="mt-[20px]" />
          <TextInput
            onTextChanged={(v) => {
              setName(v);
              if (errors.name) setErrors((e) => ({ ...e, name: false }));
            }}
            error={errors.name}
          />
          <PhoneNumberInput
            label="Phone number"
            value={phone}
            required
            showError={submitted}
            onChange={(v) => {
              setPhone(v);
              if (errors.phone) setErrors((e) => ({ ...e, phone: false }));
            }}
            labelClassName="text-[12px] font-OpenSansMedium font-[600] text-inputEmailTitle"
          />
          <div className="mt-[10px]" />
          <PasswordInput
            onPasswordChanged={(v) => {
              setPassword(v);
              if (errors.password) setErrors((e) => ({ ...e, password: false }));
            }}
            isForgotButton={false}
            error={errors.password}
          />
          <ConfirmPasswordInput
            onConfirmpasswordChanged={(v) => {
              setConfirmPassword(v);
              if (errors.confirmPassword) setErrors((e) => ({ ...e, confirmPassword: false }));
            }}
            error={errors.confirmPassword}
          />
          <BlueButton onButtonClicked={blueButtonClicked} title={"SET PASSWORD"} isLoading={isLoading} />
        </div>
      </div>
    </div>
  );
}

export default SetPassword;
